import Inherit from '../../core/inherit';
import ShelfController from '../../core/shelf.controller';
import SegmentsDelegate from './segments.delegate';

class SegmentsController extends Inherit(ShelfController, SegmentsDelegate) {
    async initialize() {
        let storeTypes = null;

        if (this.isAuthenticated) {
            storeTypes = await this.data.fetchStoreTypes();
        } else this.navigateLogin();

        const visible = this.visibleStoreTypes(storeTypes || []);
        this.setState({ storeTypes: visible, rows: visible, loading: false });
    }

    /** Seam: the segmentations this page lists. Companies narrow it (companies/<id>/pages). */
    visibleStoreTypes(storeTypes) {
        return storeTypes;
    }

    /** Filters the table by segment label and refreshes the autocomplete suggestions. */
    searchSegments(search) {
        const { storeTypes } = this.state;
        this.setSearch(search);
        if (!search || typeof search !== 'string') {
            this.setSuggestions([]);
            this.setRows(storeTypes || []);
            return;
        }
        const filteredData = storeTypes?.filter((c) => c.label && c.label.toLowerCase().includes(search.toLowerCase())) || [];
        this.setSuggestions(filteredData.map((c) => c.label));
        this.setRows(filteredData);
    }
}

export default SegmentsController;
